module.exports = __webpack_public_path__ + "static/media/Draco.82e76e7e.png";